<style scoped>
body {
  background: #F6F5FA;
}
  .page {
    padding: 8px;
    margin-top: -48px;
  }
  .banner {
    margin: 16px 0;
  }

  .page_content {
    padding-top: 8px;
    font-size: 14px;
    color: #222222;
  }
</style>
<template>
  <div class="page">
    <h3>{{ title }}</h3>
    <v-card class="banner">
      <v-img round :src="img">
      </v-img>
    </v-card>
    <div class="page_content font-weight-light" v-html="content"></div>
    <v-snackbar v-model="snackbar" top>
      {{ text }}
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from "qs"
  export default {
    name: 'articleItem',
    data() {
      return {
        title: '',
        img: '',
        content: '',
        text: '',
        snackbar: false,
        articleId: this.$route.query.articleId
      }
    },
    mounted() {
      var vm = this;
      let params = {
        articleId: vm.articleId,
        c: "2",
        ch: "1",
        deviceIp: "fe80%3A%3Ab252%3Aa809%3A2875%3A5684",
        format: "json",
        imei: "E3DDA838-BC9B-4206-B330-3FF5EDECF79E",
        osv: "13.1.3",
        pf: "apple",
        pi: "0",
        pm: "iPhone",
        sign: "5dcbcc9a9385f723c7460dea976832cd",
        t: "E3DDA838-BC9B-4206-B330-3FF5EDECF79E",
        ui: "200011",
        v: "1.0.0"
      };
      let baseApi = 'https://www.liferesting.com'; //https://www.liferesting.com  https://interface.liferesting.com  FindArtcle
      // let baseApi = '';
      axios.post(baseApi + '/api/FindArtcle/interface', qs.stringify(params)).then(response => {
        // eslint-disable-next-line no-console
        let res = response.data;
        if (res.result === '0') {
          vm.title = res.title
          vm.img = res.img;
          // eslint-disable-next-line no-control-regex
          let reg=new RegExp("\n","g"); 
          let str= res.content.replace(reg,"<br>");
          vm.content =str;  
        } else {
          vm.text = res.message
          vm.snackbar = true
        }
      });
    }
  }
</script>